<template>
  <a-result status="404"
            title="404"
            sub-title="页面不存在">
    <template #extra>
      <a-button type="primary" @click="backHome">
        返回首页
      </a-button>
    </template>
  </a-result>

</template>

<script>

  export default {
    name: 'page404',
    data () {
      return {}
    },
    methods: {
      backHome () {
        this.$router.push('/')
      },
    },
  }
</script>

<style scoped>
</style>